import { createElement as _createElement } from "@emotion/react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useBreakpointDown } from '@travel-frontend/core';
import { Layout } from '../../components/TrustElements/components/Layout.js';
import { TrustElement } from '../../components/TrustElements/components/TrustElement.js';
import { TrustElementsStack } from '../../components/TrustElements/components/TrustElementsStack.js';
import { HeadlineLarge } from '../../primitives/index.js';
export const TrustElements = ({
  elements,
  headline
}) => {
  const lgDown = useBreakpointDown('lg');
  if (!elements) return null;
  return _jsxs(Layout, {
    direction: "column",
    alignItems: "center",
    spacing: lgDown ? 1 : 2,
    children: [headline && _jsx(HeadlineLarge, {
      children: headline
    }), _jsx(TrustElementsStack, {
      direction: "row",
      spacing: lgDown ? 1 : 2,
      children: elements.map((element, index) => _createElement(TrustElement, {
        ...element,
        key: index
      }))
    })]
  });
};